enum Referer {
  NO_ANSWER = -1,
  WEB_SEARCH = 0,
  SNS = 1,
  FRIEND = 2,
  OTHER = 3
}

// tslint:disable-next-line:no-namespace
namespace Referer {
  export function info(referer: Referer): RefererInfo {
    switch (referer) {
      case Referer.NO_ANSWER:
        return { name: '未回答' }
      case Referer.WEB_SEARCH:
        return { name: 'WEB検索' }
      case Referer.SNS:
        return { name: 'SNS' }
      case Referer.FRIEND:
        return { name: '知人から' }
      case Referer.OTHER:
        return { name: 'その他' }
      default:
        throw new Error('予期せぬRefererです。')
    }
  }
}

interface RefererInfo {
  name: string
}

export { Referer, RefererInfo }
